import React from 'react';
import BillFlowListContainer from '../../containers/billflow/BillFlowListContainer';

const BillFlowListPage = () => {
  return <BillFlowListContainer />;
};

export default BillFlowListPage;
